<template>
    <div class="ts_search">
        <div class="query">
            <div class="query_header">
                <slot name="prepend"></slot>
                <div class="search_div">
                    <!-- <div class="search_div_box"> -->
                        <el-select
                            v-model="boxSearchValue"
                            multiple
                            filterable
                            clearable
                            remote
                            default-first-option
                            placeholder="请输入关键词"
                            :remote-method="keyRemoteMethod"
                            @change="searchValueChange"
                            @keyup.enter.native="searchClick"
                            class="query_select"
                            ref="searchRef">
                            <el-option
                                v-for="item in boxSearchOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <i class="el-icon-search search_btn" @click="searchClick"></i>
                    </div>
                    <el-tooltip class="item" effect="dark" :content="more ? '收起筛选' : '展开筛选'" placement="bottom" :open-delay="500" v-if="moreSearchItems.length > 0">
                        <el-badge :value="badge" :max="99" class="item" type="primary" :hidden="!badge">
                            <div :class="more ? 'more_btn_true more_btn' : 'more_btn_false more_btn'" @click="moreSearchChange">
                                <i class="tsiconfont icon-shaixuan more_icon"></i>
                            </div>
                        </el-badge>
                    </el-tooltip>
                    <!-- <el-tooltip class="item" effect="dark" content="清空" placement="bottom" :open-delay="500">
                        <div class="clear_btn" @click="clearAllTab">
                            <i class="el-icon-third-lajitong more_icon"></i>
                        </div>
                    </el-tooltip> -->
                    <el-tooltip class="item" effect="dark" content="重置" placement="bottom" :open-delay="500">
                        <div class="clear_btn" @click="reset">
                            <i class="el-icon-refresh-right more_icon"></i>
                        </div>
                    </el-tooltip>
                <slot name="append"></slot>
            </div>
            <slot name="button" class="query_header_button"></slot>
        </div>
        <div class="tabs_div">
            <MoreFilter :moreSearchItems.sync="moreSearchItems" v-show="more" @pushTab="pushTab" ref="moreFilter"/>
            <slot name="tabs"></slot>
        </div>
    </div>
</template>

<script>
    import MoreFilter from './MoreFilter.vue';

    export default {
        name: 'TsSearch',
        components: {
            MoreFilter
        },
        props: {
            searchUrl: {
                type: String,
                default: ''
            },
            boxSearchItems: {
                type: Array,
                default: () => []
            },
            moreSearchItems: {
                type: Array,
                default: () => []
            }
        },
        mounted() {
            this.reset();
            this.$nextTick(() => {
                this.isDefault = false;
            });
        },
        data() {
            return {
                isDefault: true,
                badge: 0,
                more: false,
                boxSearchOptions: [],
                boxSearchValue: [],
                moreSearchValue: {}
            };
        },
        computed: {
            searchValue() {
                let searchObj = {
                    ...this.moreSearchValue
                };
                this.boxSearchValue.forEach(item => {
                    searchObj[this.boxSearchItems.find(i => i.name === item.split('：')[0]).param] = item.split('：')[1];
                });
                return searchObj;
            }
        },
        watch: {
            searchValue: {
                deep: true,
                handler() {
                    this.badge = Object.keys(this.moreSearchValue).length;
                    if(!this.isDefault) {
                       this.searchClick();
                    }
                }
            }
        },
        methods: {
            reset() {
                if (this.moreSearchItems.some(item => item.defaultSearchValue)) {
                    this.more = true;
                }
                this.boxSearchValue = [];
                this.$refs.moreFilter.reset();
            },
            clearAllTab() {
                if (this.boxSearchValue.length > 0 || Object.keys(this.moreSearchValue).length > 0) {
                    this.boxSearchValue = [];
                    this.moreSearchValue = {};
                    this.$refs.moreFilter.clearAllTab();
                }
            },
            searchClick() {
                this.$emit('reSearch', this.searchValue)
            },
            pushTab(obj) {
                this.moreSearchValue = obj;
            },
            moreSearchChange() {
                this.more = !this.more;
                this.$emit('moreSearchChange', this.more);
            },
            searchValueChange(e) {
                let boxSearchValue = [];
                e.filter(item => {
                    let index = boxSearchValue.findIndex(i => i.split('：')[0] === item.split('：')[0]);
                    if (index !== -1) {
                        boxSearchValue.splice(index, 1);
                    }
                    boxSearchValue.push(item);
                })
                this.boxSearchValue = boxSearchValue;
            },
            keyRemoteMethod(query) {
                this.boxSearchOptions = [];
                if (query !== '') {
                    this.boxSearchItems.forEach(item => {
                        this.boxSearchOptions.push({
                            value: `${item.name}：${query}`,
                            label: `${item.name}：${query}`
                        })
                    })
                } else {
                    this.boxSearchOptions = [];
                }
            }
        }
    };
</script>

<style lang="scss">
    .divider {
        margin: 12px;
    }
    .ts_search {
        background-color: #fff;
        // height: 100%;
    }
    .query {
        background-color: #fff;
        width: 100%;
        padding: 20px 0 10px 0;
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .query_header {
        display: flex;
    }
    .tabs_div {
        background-color: #fff;
        width: 100%;
        z-index: 10;
        .el-tabs__header {
            margin: 0;
        }
    }
    .tabs {
        margin-left: 34px
    }
    ::v-deep #views {
        background-color: #fff !important;
    }
    .search_div {
        width: 542px;
        min-height: 40px !important;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        display: flex;
        align-items: center;
        .el-select__input {
            width: auto !important;
            margin-left: 9px;
        }
        .el-select__tags {
            white-space: nowrap !important;
            overflow: hidden !important;
            flex-wrap: nowrap;
            margin-left: 6px;
        }
        .el-tag{
            margin: 2px 6px 2px 0;
        }
    }
    .search_div_box {
        display: flex;
        align-items: center;
    }
    .customer_select .el-input__inner {
        border: none;
    }
    .query_select {
        width: 500px;
        border: none;
    }
    .customer_div {
        height: 40px !important;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
    }
    .query_select .el-input__inner {
        border: none;
    }
    .search_btn {
        cursor: pointer;
        color: #666;
        font-size: 28px;
    }
    .more_icon {
        font-size: 24px;
    }
    .more_btn {
        margin-left: 10px;
        border-radius: 5px;
        width: 40px;
        height: 40px;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .clear_btn {
        margin-left: 10px;
        border-radius: 5px;
        width: 40px;
        height: 40px;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #e6e6e6;
    }
    .more_btn_true {
        color: #056dff;
        border: 1px solid #056dff;
    }
    .more_btn_false {
        color: #262626;
        border: 1px solid #e6e6e6;
    }
</style>
